import * as ReselectModule from "reselect";
import { IClientBenefitListState } from ".";
import { IApplicationState } from "..";

export const selectClientBenefitList: ReselectModule.Selector<
  IApplicationState,
  IClientBenefitListState
> = (state) => state.clientBenefitList;
